module.exports = "<footer class=\"app-footer\">\n  <!--<span><a href=\"http://coreui.io\">CoreUI</a> &copy; 2017 creativeLabs.</span>-->\n  <!--<span class=\"ml-auto\">Powered by <a href=\"http://coreui.io\">CoreUI</a></span>-->\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/midac/midac-live/app/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main